/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	wrapper: {
		color: token('color.text.subtlest', '#253858'),
		font: token(
			'font.body.small',
			'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
		),
		marginBottom: token('space.200', '16px'),
	},
	line: {
		width: '100%',
		borderColor: token('color.border', 'rgba(9, 30, 66, 0.66)'),
		borderStyle: 'solid',
		borderWidth: token('border.width', '1px'),
	},
});

export const LineDivider = () => {
	return (
		<Inline alignBlock="center" alignInline="center" xcss={styles.wrapper}>
			<Box as="span" xcss={styles.line} />
		</Inline>
	);
};
